import { render, staticRenderFns } from "./SelfBuild.vue?vue&type=template&id=51565cbf"
import script from "./SelfBuild.vue?vue&type=script&lang=js"
export * from "./SelfBuild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports